import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://betamr.info/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// ?? Interceptor pour �viter le cache (solution globale)
axiosInstance.interceptors.request.use((config) => {
  config.params = {
    ...(config.params || {}),
    _t: Date.now(),
  };
  return config;
});

export default axiosInstance;

export const axiosSession = axios.create({
  baseURL: "https://betamr.info/api",
  withCredentials: true,
});

// ?? m�me logique pour axiosSession
axiosSession.interceptors.request.use((config) => {
  config.params = {
    ...(config.params || {}),
    _t: Date.now(),
  };
  return config;
});